module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#automobile",
      toString: function () {
        return this.url;
      }
    }